import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import
  styled
from 'styled-components';

import {
  Text
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

const Link = styled.a`
  text-decoration: none;
  display: flex;
  height: 50px;
  minHeight: 50px;
  width: 100%;
  maxWidth: 320px;
  margin: auto 0 32px;
  background-color: ${CustomColors.Red1};
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
`;

export const Anchor = props => {

  return (

    <Link
      id={props.id}
      automationId={props.automationId}
      href={props.enableHref ? props.href : undefined}
      onClick={!props.enableHref ? props.redirectFnc : undefined}>

      <Text
        color={props.textColor}
        fontSize={props.fontSize}
        textAlign={props.textAlign}
        fontFamily={props.fontFamily}
        fontWeight={props.fontWeight}>

        {props.text}
      </Text>
    </Link>
  );
};

Anchor.propTypes = {
  id: PropTypes.string,
  automationId: PropTypes.string,
  text: PropTypes.string.isRequired,
  margin: PropTypes.string,
  padding: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  fontFamily: PropTypes.string,
  textAlign: PropTypes.string,
  redirectFnc: PropTypes.func,
  enableHref: PropTypes.bool,
  href: PropTypes.string
};

Anchor.defaultProps = {
  id: 'unknown-link',
  automationId: 'unknown-link',
  text: PropTypes.string,
  margin: '',
  padding: '',
  activeBackgroundColor: CustomColors.Red1,
  textColor: CustomColors.White,
  fontSize: '16px',
  fontWeight: '500',
  fontFamily: 'Roboto',
  textAlign: 'center',
  redirectFnc: () => {},
  enableHref: false,  
  href: undefined
};